export { default } from './Icon';
export { default as SvgIcon } from './SvgIcon';
export { getLocalSvgIconString, getLocalSvgIcon, getSvgIcon } from './utils';
